import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=007dbbe8&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('007dbbe8')) {
      api.createRecord('007dbbe8', component.options)
    } else {
      api.reload('007dbbe8', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=007dbbe8&", function () {
      api.rerender('007dbbe8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4h3u5z1Z3gd7G/JS/comp/ErrorMessage.vue"
export default component.exports